import { Component, OnDestroy, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { filter } from 'rxjs/operators';
import { ToastService } from '../../../../main/services';
import { PROPOSAL_STEPS, Proposal } from '../../../../supplier/models';
import { Tender } from '../../../models/tender';
import { ProposalService } from '../../../services';
@Component({
    selector: 'jft-input-bid-steps',
    templateUrl: './input-bid-steps.component.html',
    styleUrls: ['./input-bid-steps.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class InputBidStepsComponent implements OnInit, OnDestroy {

    public tender: Tender;
    public proposal: Proposal;

    private routerSubscribtion: Subscription;
    public stepsCompleted = 0;

    public invitationLink: string;
    public conditionLink: string;
    public contractsLink: string;
    public reviewLink: string;
    public proposalSteps = PROPOSAL_STEPS;
    public currentRouteUrl: string;
    public companyId: number;
    public bidLink: string;
    public parsedUrl: any;

    constructor(
        private route: ActivatedRoute,
        private router: Router,
        private service: ProposalService,
        private toast: ToastService,
    ) {
    }

    public ngOnInit() {
        let data = this.route.snapshot.data;
        this.companyId = this.route.snapshot.params.id;
        this.tender = data['tender'];
        this.proposal = data['proposal'];

        this.invitationLink = `/tenders/${this.tender.id}/supplier/${this.companyId}/input-bid/flow/invitation`;
        this.conditionLink = `/tenders/${this.tender.id}/supplier/${this.companyId}/input-bid/flow/supply-conditions`;
        this.contractsLink = `/tenders/${this.tender.id}/supplier/${this.companyId}/input-bid/flow/locations`;
        this.reviewLink = `/tenders/${this.tender.id}/supplier/${this.companyId}/input-bid/flow/review`;
        this.bidLink = this.getBidLink();

        this.currentRouteUrl = this.router.url;
        this.stepsCompleted = this.getStepsCompleted();

      this.routerSubscribtion = this.router.events.pipe(filter((event) => {
        return event instanceof NavigationEnd;
      })).subscribe((params: any) => {
            this.currentRouteUrl = params.url;
            this.stepsCompleted = this.getStepsCompleted();
            this.bidLink = this.getBidLink()
        });
    }

    private getBidLink() {
        let parsedUrl = this.router.url.split('/');
        let bidId = parsedUrl[parsedUrl.length - 2];
        return `/tenders/${this.tender.id}/supplier/${this.companyId}/input-bid/flow/locations/${bidId}/bid`
    }

    private getStepsCompleted() {
        switch (this.proposal.step) {
            case PROPOSAL_STEPS.INVITATION:
                return 0;
            case PROPOSAL_STEPS.SHARE_ACCESS:
                return 1;
            case PROPOSAL_STEPS.SUPPLY_CONDITIONS:
                return 2;
            case PROPOSAL_STEPS.BIDS:
                return 3;
            case PROPOSAL_STEPS.REVIEW:
                return 4;
            case PROPOSAL_STEPS.DONE:
                return 5;
        }
    }

    public isStepCompleted(index: number) {
        return index <= this.stepsCompleted;
    }

    public isStepDisabled(step: PROPOSAL_STEPS): boolean {
        // If we are at step 1 (Invitation) and haven't accepted yet,
        // we can't go to ANY other step except Invitation itself.
        if (this.proposal.step === PROPOSAL_STEPS.INVITATION && step !== PROPOSAL_STEPS.INVITATION) {
            return true;
        }

        return false;
    }

    public goToStep(step) {
        if (this.isStepDisabled(step)) {
            this.toast.warning('Please accept or decline the invitation before proceeding');
            return;
        }

        this.service.goToStep(this.tender, this.proposal, step, this.companyId)
            .subscribe((proposal) => {
                this.router.navigateByUrl(this.getStepLink(step));
            }, (e) => {
            this.toast.error(e);
            });
    }

    private getStepLink(step) {
        switch (step) {
            case PROPOSAL_STEPS.INVITATION:
                return this.invitationLink;
            case PROPOSAL_STEPS.SUPPLY_CONDITIONS:
                return this.conditionLink;
            case PROPOSAL_STEPS.BIDS:
                return this.contractsLink;
            case PROPOSAL_STEPS.REVIEW:
                return this.reviewLink;
        }
    }

    public isCurrentLink(step) {
        let stepLink = this.getStepLink(step);
        if (PROPOSAL_STEPS.BIDS == step) {
            return stepLink == this.currentRouteUrl || this.bidLink == this.currentRouteUrl;
        } else {
            return stepLink == this.currentRouteUrl;
        }
    }

    public ngOnDestroy(): void {
        this.routerSubscribtion.unsubscribe();
    }
}
